import { ScrollView } from '@mythical/ui'
export const GestureHandlerScrollView = ScrollView
